import dayjs from "dayjs"
import qs from "query-string"
import { useNavigate, useLocation } from "react-router-dom"
import { update } from "lodash-es"

export function useSearchFilter(
  defaultValue?: any
): [{ page: any; search: any; date: any; [key: string]: any }, any] {
  const navigate = useNavigate()
  const location = useLocation()
  const parsed = qs.parse(location.search)

  function handleChange(value: any) {
    // Allow value to be a function so we have same API as useState
    const valueToStore = value instanceof Function ? value(parsed) : value
    valueToStore?.date &&
      update(valueToStore, "date", d => dayjs(d).format("YYYY-MM-DD"))
    navigate({
      pathname: location.pathname,
      search: qs.stringify(valueToStore),
    })
  }

  return [
    {
      ...defaultValue,
      ...parsed,
      page: parsed?.page ?? 0,
      search: parsed?.search,
      date:
        parsed?.date === null || parsed?.date === "No Date!"
          ? null
          : parsed?.date ?? dayjs().format("YYYY-MM-DD"),
    },
    handleChange,
  ]
}

export function useQueryString(key: string) {
  const navigate = useNavigate()
  const location = useLocation()
  const parsed = qs.parse(location.search)

  function handleChange(value: any) {
    navigate({
      pathname: location.pathname,
      search: qs.stringify({
        ...parsed,
        [key]: value,
      }),
    })
  }
  return [parsed?.[key] as string, handleChange] as const
}
